import { createMichelinBrandThemeOptions } from "./createMichelinBrandThemeOptions";
var lightMichelinThemeOptions = createMichelinBrandThemeOptions('light');
export { lightMichelinThemeOptions };